import React, { useContext, useMemo } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { BannerContext } from "./BannerProvider";
import Skeleton from "@mui/material/Skeleton";
import "./ImageSlider.css";
import { motion } from 'framer-motion';

const ElectronicCollectionBanner = React.memo(() => {
  const { banners, isLoading } = useContext(BannerContext);

  const carouselContent = useMemo(() => {
    if (!Array.isArray(banners) || banners.length === 0) {
        return <p>No banners available</p>; // Fallback UI
      }
    return banners.map((image, index) => (
      <motion.div 
        key={index}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: false }}
        transition={{ duration: 0.5 }}
      >
        <img src={image} alt={`Banner ${index + 1}`} />
      </motion.div>
    ));
  }, [banners]);

  if (isLoading) {
    return (
      <div className="carousel-image-slider-container">
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={"45vw"}
          animation="wave"
        />
      </div>
    );
  }

  return (
    <motion.div 
      className="carousel-image-slider-container"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <Carousel
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        showArrows={true}
        showThumbs={false}
        stopOnHover={true}
        showStatus={false}
      >
        {carouselContent}
      </Carousel>
    </motion.div>
  );
});

export default ElectronicCollectionBanner;